import React from "react";
import "./main.css"
import {Link} from "react-router-dom";
import {ru} from "../data/ru"
import {by} from "../data/by"
import {INFORMATION_URL, TESTS_URL} from "../../config";
import style from './main.module.css'
import AuthForm from "./authForm";
import IsLoginPanel from "./isLoginPanel";
export default function Main() {
    let language = localStorage.getItem('lang') === 'ru' ? ru.mainpage : by.mainpage
    const isLogin = localStorage.getItem('isLoggedIn') === '1';
    console.log(isLogin)
    return (
        <div className="main-container">
            <div className="main-picture">
                <div className={style.blackout}>
                    <div className={style.mainContainer}>
                    <div className={style.leftBlock}>
                        <h1>{language.upperText}</h1>
                    </div>
                    <div className={style.rightBlock}>
                        {isLogin ? <IsLoginPanel/>:<AuthForm/>}
                        <div className={style.secondBlock}>
                            <div className={style.buttonContainer}>
                                <Link to={INFORMATION_URL}>
                                    <button className={style.buttonInfo}>{language.more}</button>
                                </Link>
                                <Link to={TESTS_URL}>
                                    <button className={style.buttonDemo}> {language.lowerTextButton} </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                    <h1 style={{
                        fontSize: '25px',
                        lineHeight: '35px',
                        textAlign: 'center',
                        color: '#f5f5f5'}}>Тренировочные задания по функциональной грамотности носят ознакомительный характер. Это задания, предполагающие использование знаний и умений для поиска решений в смоделированных жизненных ситуациях, с которыми учащиеся могут столкнуться сейчас или в будущем.
                        Данные материалы представляют интерес для учащихся, их родителей, педагогических работников, специалистов в области образования и могут быть использованы при подготовке к национальному исследованию качества образования (НИКО).
                        Работа с этими материалами позволит получить всем заинтересованным лицам общее представление о структуре и типологии заданий НИКО, объеме и форме их предъявления.
                        При этом следует учитывать тот факт, что представленные материалы не идентичны заданиям, которые будут использованы в самом исследовании.
                        Опыт выполнения подобных заданий поможет учащимся более успешно проявить себя в НИКО.
                        Желаем успеха!</h1>
                </div>
            </div>
                       {/*<div className="main-last-picture">*/}
            {/*    <div className="main-section-third">*/}
            {/*        <p>{language.lowerText1}</p><br/>*/}
            {/*        <p>*/}
            {/*            {language.lowerText2}<br/>*/}
            {/*            {language.lowerText3}<br/>*/}
            {/*            {language.lowerText4}<br/>*/}
            {/*            {language.lowerText5}<br/>*/}
            {/*            {language.lowerText6}<br/>*/}
            {/*        </p>*/}
            {/*        <Link to={TESTS_URL} className="section_test_button">{language.lowerTextButton}</Link>*/}
            {/*        <p className="main-developer"> {language.lastText}</p>*/}
            {/*    </div>*/}

            {/*</div>*/}

        </div>
    )
}
